import { cx } from '@linaria/core';
import { useId } from 'react';
import { urlPatterns } from '@pm2/sitemap-utils';
import { Link } from '@provider/navigation';
import { OpenInternalIcon, DownloadIcon, OpenIcon, OpenExternalIcon, DisjointExpandIcon } from '@ui/kit';
import { expandableIconCls, tooltip, tooltipArrow, linkCls, expandableCls, buttonCls } from './styles/LinkWrapper.js';
import { jsx, Fragment, jsxs } from 'react/jsx-runtime';

function LinkWrapper(props) {
  const id = useId();
  if (props.link) {
    const isElementLink = props.link.href.includes("learningObject");
    const elementId = props.link.href.replace(/\/learningobject\//gi, "");
    const href = isElementLink ? urlPatterns.element(elementId) : props.link.href;
    const linkDescription = (() => {
      if (isElementLink) {
        return {
          icon: /*#__PURE__*/jsx(OpenInternalIcon, {
            height: 22
          }),
          text: "Gå til indholdselement"
        };
      }
      if (props.link?.href.includes(process.env["PM2_MEDIA_DOMAIN"] ?? "")) {
        return {
          icon: /*#__PURE__*/jsx(DownloadIcon, {
            height: 22
          }),
          text: "Hent fil"
        };
      }
      switch (props.link?.target) {
        case "_blank":
          return {
            icon: /*#__PURE__*/jsx(OpenExternalIcon, {
              height: 22
            }),
            text: "Gå til relateret indhold i ny fane"
          };
        case "_lightbox":
          return {
            icon: /*#__PURE__*/jsx(OpenIcon, {
              height: 22
            }),
            text: "Åbn relateret indhold i lightbox"
          };
        default:
          return {
            icon: /*#__PURE__*/jsx(OpenInternalIcon, {
              height: 22
            }),
            text: "Gå til relateret indhold"
          };
      }
    })();
    return /*#__PURE__*/jsx(Fragment, {
      children: /*#__PURE__*/jsxs(Link, {
        className: cx(linkCls, expandableCls),
        href: href,
        target: props.link.target,
        "aria-describedby": `description-${id}`,
        children: [props.children, props.state === "success" && /*#__PURE__*/jsxs("span", {
          className: expandableIconCls,
          id: `description-${id}`,
          children: [/*#__PURE__*/jsxs("span", {
            className: tooltip,
            "data-disable-polly": true,
            children: [linkDescription.text, " ", /*#__PURE__*/jsx("span", {
              className: tooltipArrow
            })]
          }), linkDescription.icon]
        })]
      })
    });
  }

  // In case the image should be opened in a lightbox but no link has been
  // provided then we must add this functionality manually.
  if (props.openInLightbox) {
    return /*#__PURE__*/jsxs("button", {
      onClick: props.openInLightbox,
      className: cx(buttonCls, props.state === "success" && expandableCls),
      children: [props.children, props.state === "success" && /*#__PURE__*/jsxs("span", {
        className: expandableIconCls,
        children: [/*#__PURE__*/jsxs("span", {
          className: tooltip,
          "data-disable-polly": true,
          children: ["Forst\xF8r billede ", /*#__PURE__*/jsx("span", {
            className: tooltipArrow
          })]
        }), /*#__PURE__*/jsx(DisjointExpandIcon, {})]
      })]
    });
  }

  // In case nothing else matches, then simply render the image as is
  return props.children;
}

export { LinkWrapper };
//# sourceMappingURL=LinkWrapper.js.map
